import type React from 'react';
import { Colors } from '@/lib/colorUtils';

export enum TextTag {
  h1 = 'h1',
  h2 = 'h2',
  h3 = 'h3',
  h4 = 'h4',
  h5 = 'h5',
  h6 = 'h6',
  p = 'p',
  span = 'span',
  label = 'label',
  div = 'div',
}

export enum TextAlign {
  left = 'tw:text-left',
  center = 'tw:text-center',
  right = 'tw:text-right',
  justify = 'tw:text-justify',
}

export type TextSize = '12' | '14' | '16' | '20' | '24' | '32' | '40' | '48';
export const TextSizes: Record<TextSize, string> = {
  12: 'tw:text-12',
  14: 'tw:text-14',
  16: 'tw:text-16',
  20: 'tw:text-20',
  24: 'tw:text-24',
  32: 'tw:text-32',
  40: 'tw:text-40',
  48: 'tw:text-48',
};

export type TextWeight = 'regular' | 'medium' | 'semibold' | 'bold';
export const TextWeights: Record<TextWeight, string> = {
  regular: 'tw:font-regular',
  medium: 'tw:font-medium',
  semibold: 'tw:font-semibold',
  bold: 'tw:font-bold',
};

export type TextLineHeight = '1' | '2' | '3';
export const TextLineHeights: Record<TextLineHeight, string> = {
  1: 'tw:leading-1',
  2: 'tw:leading-2',
  3: 'tw:leading-3',
};

export interface TextBaseProps {
  children: React.ReactNode;
  size?: TextSize;
  color?: Colors;
  weight?: TextWeight;
  lineHeight?: TextLineHeight;
  /**
   * Optional HTML tag to render. When omitted, defaults to `div`.
   * Can be a `TextTag` enum value or any valid React element type.
   */
  tag?: React.ElementType | TextTag;
  truncate?: boolean;
  textAlign?: TextAlign;
  className?: string;
}

export type TextProps<TTag extends React.ElementType = 'div'> = TextBaseProps &
  Omit<React.ComponentPropsWithoutRef<TTag>, keyof TextBaseProps | 'as'> & { tag?: TTag };
